import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

export interface TableFooterProps {
  children?: ReactNode;
  className?: string;
}

/** A status row under the grid for the consumer's own content, such as a row count. */
export const TableFooter = ({ children, className }: TableFooterProps) => (
  <div
    data-slot="table-footer"
    className={cn("flex items-center justify-between py-2 text-sm text-muted-foreground", className)}
  >
    {children}
  </div>
);
